import React, {Component} from 'react';
import CommunityPage from './CommunityPage';
import './CommunityMembersPage.css';
import {
	retrieveCommunity,
	approveMembership,
	rejectMembership,
	applyAdmin,
	joinCommunity
} from './community.actions';
import {connect} from 'react-redux';
import {Spinner} from '../widgets';
import {ProfileCard} from '../profile';
import {
	getSessionUserMembership,
	getApprovedMembersByCategory,
	getPendingMembers,
	getSortedCategories,
	getAdmins,
	canAdmin,
	getProfileUniqueName,
	getParamsUniqueName
} from './community.selectors';
import {DocumentTitle, EmptyMessage, TaxonomyList, PrimaryButton} from '../widgets/';
import communityActions from './community.actions';
import CommunityAdminList from './CommunityAdminList';
import UserProfileCard from '../profile/UserProfileCard';
import ProviderSearchDropdown from '../search/ProviderSearchDropdown';
import userHasBaseDetails from '../user/userHasBaseDetails';
import {B2ME_COMM_UUID} from './index';

export class CommunityMembersPage extends CommunityPage {
	constructor(props) {
		super(props);

		const paramUniqueName = getParamsUniqueName(this.props);
		if (
			paramUniqueName &&
			(!this.props.community || getProfileUniqueName(this.props) !== paramUniqueName)
		) {
			props.retrieveCommunity(paramUniqueName);
		}
		this.communityCategoryRefs = {};
		this.scrollMembersIntoView = categoryName => {
			this.communityCategoryRefs[categoryName].scrollIntoView({
				behaviour: 'smooth',
				block: 'start'
			});
			window.scrollBy(0, -48); // have to offset scroll by nav height
		};
	}

	render() {
		if (!this.props.community || !this.props.community.profile) {
			return (
				<DocumentTitle title="B2Me">
					<main className="CommunityMembersPage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		if (!this.props.community.members) {
			return (
				<DocumentTitle title="B2Me">
					<main className="CommunityMembersPage">
						<EmptyMessage>This community does not yet have any members </EmptyMessage>
					</main>
				</DocumentTitle>
			);
		}

		const {
			community: {uuid},
			approveMembership,
			rejectMembership,
			sessionProvider,
			applyAdmin,
			joinCommunity,
			inviteUser
		} = this.props;

		const isAdmin = canAdmin(this.props);
		const sessionUserMembership = getSessionUserMembership(this.props);
		const pendingMembers = getPendingMembers(this.props);
		const approvedMembersByCategory = getApprovedMembersByCategory(this.props);
		const sortedCategories = getSortedCategories(this.props);

		// sorting community members in each category according to their firstname
		for (const category in approvedMembersByCategory) {
			approvedMembersByCategory[category].sort((providerA, providerB) => {
				if (providerA['user'].lastname < providerB['user'].lastname) {
					return -1;
				}
				if (providerA['user'].lastname > providerB['user'].lastname) {
					return 1;
				}
				return 0;
			});
		}

		return (
			<DocumentTitle title={`${this.props.community.name} - B2Me`}>
				<main className="CommunityMembersPage">
					<section>
						{joinCommunity &&
							userHasBaseDetails(sessionProvider) &&
							!sessionUserMembership &&
							uuid !== B2ME_COMM_UUID && (
								<PrimaryButton
									onClick={joinCommunity}
									icon="person_add"
									disabled={sessionProvider.user.exceededMembershipLimit}>
									Join this community
								</PrimaryButton>
							)}
						{sessionProvider &&
							sessionUserMembership &&
							sessionUserMembership.status === 'approved' && (
								<div className="CommunityMembersPage-invite" ref={el => (this.elInvite = el)}>
									<label>
										Invite someone to <em>{this.props.community.name};</em>
									</label>
									<ProviderSearchDropdown
										onSelect={inviteUser}
										scrollIntoViewElement={() => this.elInvite}
									/>
								</div>
							)}
						<TaxonomyList className="CommunityMembersPage-taxonomies">
							{pendingMembers && pendingMembers.length > 0 && (
								<li className="selected">
									<a href="#pending">Pending</a>
								</li>
							)}
							{sortedCategories &&
								sortedCategories.map((categoryName, idx) =>
									categoryName ? (
										<li key={categoryName}>
											<a onClick={() => this.scrollMembersIntoView(categoryName)}>{categoryName}</a>
										</li>
									) : (
										undefined
									)
								)}
						</TaxonomyList>
						<CommunityAdminList />
					</section>
					<section className="CommunityMembersPage-details">
						<article className="CommunityMembersPage-members">
							<div className="CommunityMembersPage-header">
								<h2>Members</h2>
							</div>
							{pendingMembers && pendingMembers.length > 0 && <h3 id="pending">Pending</h3>}
							{pendingMembers && pendingMembers.length > 0 && (
								<ol>
									{pendingMembers.map(provider => (
										<PendingMember
											key={provider.uuid}
											provider={provider}
											isAdmin={isAdmin}
											approveMembership={approveMembership}
											rejectMembership={rejectMembership}
										/>
									))}
								</ol>
							)}
							<h3>Current members</h3>
							{sortedCategories &&
								sortedCategories.map((categoryName, idx) => (
									<div key={categoryName} className="CommunityMembersPage-member-list">
										<h4 ref={instance => (this.communityCategoryRefs[categoryName] = instance)}>
											{categoryName}
										</h4>
										<ol>
											{approvedMembersByCategory[categoryName].map(provider =>
												provider.subscriptionLevel !== 'none' ? (
													<ProfileCard
														key={provider.uuid}
														provider={provider}
														options={
															isAdmin &&
															sessionProvider.provider.uuid !== provider.uuid && [
																provider.membership.admin
																	? {
																			key: 'header',
																			icon: 'icon icon-verified_user',
																			label: 'Revoke admin privileges',
																			onSelect: () => applyAdmin(provider.user.uuid, false)
																	  }
																	: {
																			key: 'header',
																			icon: 'icon icon-verified_user',
																			label: 'Grant admin privileges',
																			onSelect: () => applyAdmin(provider.user.uuid, true)
																	  },
																{
																	key: 'delete',
																	icon: 'icon icon-block',
																	label: 'Remove this user',
																	onSelect: () => rejectMembership(provider.user.uuid)
																}
															]
														}
													/>
												) : (
													<UserProfileCard
														key={provider.uuid}
														profile={provider}
														options={
															isAdmin &&
															sessionProvider.provider.uuid !== provider.uuid && [
																provider.membership.admin
																	? {
																			key: 'header',
																			icon: 'icon icon-verified_user',
																			label: 'Revoke admin privileges',
																			onSelect: () => applyAdmin(provider.user.uuid, false)
																	  }
																	: {
																			key: 'header',
																			icon: 'icon icon-verified_user',
																			label: 'Grant admin privileges',
																			onSelect: () => applyAdmin(provider.user.uuid, true)
																	  },
																{
																	key: 'delete',
																	icon: 'icon icon-block',
																	label: 'Remove this user',
																	onSelect: () => rejectMembership(provider.user.uuid)
																}
															]
														}
													/>
												)
											)}
										</ol>
									</div>
								))}
						</article>
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

/**
 * Pending member, whose membership can be approved or rejected by the community admins.
 */
class PendingMember extends Component {
	constructor() {
		super();

		this.approve = () => this.props.approveMembership(this.props.provider.user.uuid);
		this.reject = () => this.props.rejectMembership(this.props.provider.user.uuid);
	}

	render() {
		const {provider, isAdmin} = this.props;

		const cardChildren = isAdmin && (
			<div className="CommunityMembersPage-actions">
				<button className="CommunityMembersPage-actions-positive" onClick={this.approve}>
					Accept
				</button>
				<button className="CommunityMembersPage-actions-negative" onClick={this.reject}>
					Ignore
				</button>
			</div>
		);

		return provider.subscriptionLevel !== 'none' ? (
			<ProfileCard provider={provider}>{cardChildren}</ProfileCard>
		) : (
			<UserProfileCard key={provider.uuid} profile={provider}>
				{cardChildren}
			</UserProfileCard>
		);
	}
}

const ConnectedCommunityMembersPage = connect(
	({community, session}) => ({
		community,
		sessionProvider: session && session.current
	}),
	dispatch => ({
		inviteUser: uuid => dispatch(communityActions.inviteUser(uuid)),
		joinCommunity: uniqueName => dispatch(communityActions.joinCommunity()),
		retrieveCommunity: uniqueName => dispatch(retrieveCommunity(uniqueName)),
		approveMembership: uuid => dispatch(approveMembership(uuid)),
		rejectMembership: uuid => dispatch(rejectMembership(uuid)),
		applyAdmin: (uuid, isAdmin) => dispatch(applyAdmin(uuid, isAdmin))
	})
)(CommunityMembersPage);

export default ConnectedCommunityMembersPage;



// WEBPACK FOOTER //
// ./src/community/CommunityMembersPage.js